import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=1841eb7a&"
import script from "./MainLayout.ts?vue&type=script&lang=ts&"
export * from "./MainLayout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports